import soundManager from "@/utils/soundManager";
export default {
    install(Vue) {
        // 防重复点击(指令实现)
        Vue.directive('preventReClick', {
                inserted(el, binding) {
                    el.addEventListener('click', () => {
                        if (!el.disabled) {
                            el.disabled = true
                            setTimeout(() => {
                                el.disabled = false
                            }, binding.value || 3000)
                        }
                    })
                }
            })
            //点击音效
        Vue.directive('clickMusic', {
            inserted(el, binding) {
                el.addEventListener('click', () => {
                    //全局只能有一个音效播放实例
                    if (!window.soundEffectInstance) {
                        window.soundEffectInstance = new soundManager();
                    }
                    //gameID key 音效名称
                    window.soundEffectInstance.playEffect(binding.gameID || 1000, binding.key || 'click');
                })
            }
        })
    }
}